import React from 'react';
import { pickWithPriority } from 'Helpers/Affordances';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import TabContent from './TabContent';

const TabContentPicker = ({ tabResource }) => {
  return pickWithPriority(tabResource, [
    [fr.relationships.tabData.name, <TabContent key={tabResource?.id()} tabResource={tabResource} />],
  ], null);
};

TabContentPicker.propTypes = {
  tabResource: PropTypes.object.isRequired,
};

export default TabContentPicker;
